import React from "react";
import { Box, Typography, Grid, Paper, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const DynamicParentPage = ({ parentPage, setPage }) => {
  if (
    !parentPage ||
    !parentPage?.subPages ||
    parentPage?.subPages?.length === 0
  ) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <Typography variant="h5" color="text.secondary">
          No content available for this section.
        </Typography>
      </Box>
    );
  }

  const handleTileClick = (path) => {
    setPage(path);
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 4 } }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", mb: 2 }}>
        {parentPage?.title}
      </Typography>

      <Typography
        variant="subtitle1"
        color="text.secondary"
        gutterBottom
        sx={{ mb: 4 }}
      >
        Select an option below to navigate to the respective report.
      </Typography>

      <Grid container spacing={4}>
        {parentPage?.subPages?.map((subPage) => (
          <Grid item key={subPage.path}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                width: 250,
                height: 100,
                borderRadius: "12px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                transition: "box-shadow 0.3s ease-in-out",
                "&:hover": {
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  cursor: "pointer",
                },
              }}
              onClick={() => handleTileClick(subPage?.path)}
            >
              <Box>
                <Typography
                  variant="h6"
                  component="h3"
                  sx={{
                    fontWeight: "bold",
                    color: "#434343",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {subPage.title}
                </Typography>
              </Box>

              <Button
                variant="text"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  mt: 2,
                  alignSelf: "flex-start",
                  color: "#434343",
                  fontWeight: "bold",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgba(67, 67, 67, 0.04)",
                    textDecoration: "underline",
                  },
                }}
              >
                Go to page
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DynamicParentPage;
